export default async function getNavigationData() {
  const navigationResult = await fetch(process.env.NEXT_PUBLIC_BE_BASE_PATH + "/rest/v1/SEA-LinMxp/contents/navigationMenu");
  const navigationData = await navigationResult.json();

  return navigationData;
}
